export default __webpack_public_path__ + "static/media/item-1.7a6d983c.png";